import Card from 'components/card';
import { ChannelIcon } from 'components/icons';

const OfferCard = (props: {
    image: string;
    offerNumber: string;
    title: string;
    author: string;
    download?: string;
    price: string | number;
    weeklyQuantity?: string | number;
    extra?: string;
    status?: string;
    buttonDisabled?: boolean;
    isKYCVerified?: boolean;
    isValidated?: boolean;
    isArchived?: boolean;
    channels: any;
    onClick?: () => void;
}) => {
    const {
        title,
        author,
        image,
        extra,
        status,
        isArchived,
        weeklyQuantity,
        offerNumber,
        onClick,
        channels,
    } = props;
    return (
        <Card
            extra={`relative flex flex-col w-full h-full !p-4 3xl:p-![18px] shadow-xl bg-white ${extra} hover:cursor-pointer hover:shadow-xl`}
            onClick={onClick}
        >
            <div className="h-full w-full">
                <div className="relative w-full">
                    {image ? (
                        <img
                            src={image}
                            className="mb-3 max-h-[130px] w-full rounded-xl 3xl:h-full 3xl:w-full"
                            alt=""
                        />
                    ) : (
                        <div className="mb-3 flex h-[130px] w-full items-center justify-center rounded-xl bg-gray-200 dark:bg-white/10">
                            <div className="text-center">
                                <p className="text-lg font-bold text-gray-400 dark:text-white">
                                    {title}
                                </p>
                                <p className="text-sm font-medium text-gray-400 dark:text-white">
                                    {author}
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
                    <div className="mb-2">
                        <div className="flex gap-2">
                            <p className="text-md font-bold text-navy-700 dark:text-white">
                                {' '}
                                {title}{' '}
                            </p>
                            <p className="my-auto flex text-xs font-bold text-gray-600">
                                #{offerNumber}
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <p className="text-sm font-medium text-gray-600 md:mt-2">
                                {author}
                            </p>
                            <div className="mt-3 flex gap-2">
                                {channels?.map((channel: string) => (
                                    <div className="text-leadrs">
                                        <ChannelIcon channel={channel} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        {status === 'running' && (
                            <p className="mt-2 text-sm font-bold text-leadrs">
                                Mission en cours
                            </p>
                        )}
                        {status === 'on_market' && (
                            <p className="mt-2 text-sm font-bold text-leadrs">
                                En attente...
                            </p>
                        )}
                        {isArchived && (
                            <p className="mt-2 text-sm font-bold text-leadrs">
                                Mission terminée
                            </p>
                        )}
                    </div>
                </div>
                <div className="mt-3 flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
                    <div className="flex">
                        <p className="mb-2 text-sm font-bold text-leadrs dark:text-white">
                            {weeklyQuantity} leads
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OfferCard;
